import {
  dashboardDocumentSchema,
  DashboardDateScopeMode,
  DashboardMetric,
  DashboardNetworkColumn,
  DashboardWidgetAction,
  DashboardWidgetType,
  DashboardWidgetWidth,
} from './model';

const inherit = { mode: DashboardDateScopeMode.Inherit } as const;

export const defaultSuperAdminDashboardDocument = dashboardDocumentSchema.parse({
  version: 1,
  widgets: [
    metric('super-admin-ad-requests', DashboardMetric.AdRequests),
    metric('super-admin-ad-impressions', DashboardMetric.AdImpressions),
    metric('super-admin-fill-rate', DashboardMetric.FillRate),
    metric('super-admin-rpm', DashboardMetric.Rpm),
    metric('super-admin-revenue', DashboardMetric.Revenue),
    metric('super-admin-profit', DashboardMetric.SuperAdminProfit),
    {
      id: 'super-admin-performance',
      type: DashboardWidgetType.PerformanceChart,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      metrics: [
        DashboardMetric.AdRequests,
        DashboardMetric.AdImpressions,
        DashboardMetric.FillRate,
        DashboardMetric.Rpm,
        DashboardMetric.Srpm,
        DashboardMetric.Revenue,
        DashboardMetric.NetworkRevenue,
        DashboardMetric.SuperAdminProfit,
      ],
      defaultVisibleMetrics: [DashboardMetric.NetworkRevenue, DashboardMetric.AdImpressions],
      actions: [DashboardWidgetAction.ViewInReporting],
    },
    {
      id: 'network-performance',
      type: DashboardWidgetType.NetworkPerformance,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      columns: [
        DashboardNetworkColumn.Network,
        DashboardNetworkColumn.AdRequests,
        DashboardNetworkColumn.AdImpressions,
        DashboardNetworkColumn.Revenue,
        DashboardNetworkColumn.NetworkProfit,
      ],
      pageSize: 10,
      actions: [DashboardWidgetAction.ViewInReporting],
    },
  ],
});

function metric(id: string, value: DashboardMetric) {
  return {
    id,
    type: DashboardWidgetType.Metric,
    width: DashboardWidgetWidth.Sixth,
    dateScope: inherit,
    metric: value,
  } as const;
}
